import api from "./api";
import {iniciarRequisicao, logout} from "../helpers/index.js"
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarSysCategorias = async (params) => {
  const url = 'sys-categorias/listagem';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.categorias;
  }

  logout();
}

export const salvarSysCategorias = async (params) => {
  const url = 'sys-categorias';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}


export const salvarSysCategoriasDosProdutos = async (params) => {
  const url = 'sys-categorias/produtos';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}
